/* A mastermind's recordings (Accelerator.dc.html's Recordings; TaggedRecordings.jsx), in the
   product's look: the heading, the line and Search by topic over the topic chips, then each
   recording with its date tile, title, length, tags, Watch and Ask about this. Colours only from the
   product's look (product.css), which takes them from tokens.css. */
.tg {
  --tg-field: var(--pp-bg); --tg-tag-bg: var(--pp-tint); --tg-tag-fg: var(--pp-soft);
  --tg-tag-on-bg: var(--pp-tint); --tg-tag-on-fg: var(--pp-accent);
  border-radius: 14px; background: var(--pp-card); border: 1px solid var(--pp-rule); overflow: hidden;
}
.pp--acc .tg { --tg-tag-bg: var(--acc-tag); --tg-tag-on-bg: var(--acc-green-2-16); --tg-tag-on-fg: var(--acc-green); }
.tg-head { padding: 24px 26px 18px; display: flex; flex-direction: column; gap: 14px; border-bottom: 1px solid var(--pp-rule); }
.tg-head-row { display: flex; align-items: flex-end; justify-content: space-between; gap: 24px; }
.tg-titles { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.tg-h { margin: 0; font-family: var(--pp-head-font); font-weight: var(--pp-heading-weight); font-size: 21px; }
.tg-h--page { font-size: 40px; line-height: 1.1; letter-spacing: -0.01em; }
.tg-line { font-size: 14px; line-height: 1.5; color: var(--pp-soft); }
.tg-search { position: relative; width: 380px; max-width: 100%; flex-shrink: 0; display: block; }
.tg-search-icon { position: absolute; left: 13px; top: 12px; fill: none; stroke: var(--pp-soft); stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.tg-search input {
  width: 100%; height: 40px; padding: 0 12px 0 38px; border-radius: 9px; border: 1px solid var(--pp-rule);
  background: var(--tg-field); font-size: 14px; color: var(--pp-ink);
}
.tg-search input::placeholder { color: var(--pp-soft); }
.tg-topics { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.tg-topics-label { font-size: 13px; color: var(--pp-soft); margin-right: 4px; }
.tg-topic {
  height: 30px; padding: 0 12px; border-radius: 15px; border: 1px solid var(--pp-rule); background: var(--pp-card);
  color: var(--pp-ink); font-size: 13px; font-weight: 500;
}
.tg-topic:hover { border-color: var(--pp-accent); }
.tg-topic--on { background: var(--pp-btn-bg); border-color: var(--pp-btn-bg); color: var(--pp-btn-fg); }
.tg-month-h {
  margin: 0; padding: 18px 26px 4px; font-size: 13px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase;
  color: var(--pp-soft);
}
.tg-row { border-bottom: 1px solid var(--pp-rule-soft); }
.tg-row:last-child, .tg-month:last-child .tg-row:last-child { border-bottom: none; }
.tg-row-main { display: flex; gap: 22px; align-items: flex-start; padding: 20px 26px; }
.tg-date {
  width: 56px; flex-shrink: 0; display: flex; flex-direction: column; align-items: center; gap: 1px; padding: 8px 0;
  border-radius: 10px; background: var(--tg-field); border: 1px solid var(--pp-rule);
  font-size: 11px; font-weight: 600; letter-spacing: 0.08em; color: var(--pp-soft);
}
.tg-date strong { font-family: var(--pp-head-font); font-size: 22px; font-weight: 700; line-height: 1.1; letter-spacing: 0; color: var(--pp-ink); }
.tg-text { flex-grow: 1; display: flex; flex-direction: column; gap: 10px; min-width: 0; }
/* a recording's 16:9 frame in place of the date tile, once the group has a thumbnail (decision 47) */
.thumb.tg-thumb { width: 176px; }
.tg-row-main--thumb ~ .tg-ask, .tg-row-main--thumb ~ .tg-sent { margin-left: 224px; }
.tg-title-line { display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap; }
.tg-title { font-family: var(--pp-head-font); font-weight: 600; font-size: 17px; }
.tg-length { font-size: 14px; color: var(--pp-soft); }
.tg-watched { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; color: var(--pp-ink); }
.tg-watched .icon-line { color: var(--pp-accent); }
/* a mastermind's recording of a session missed live and not watched (TaggedRecordings.jsx, the Accelerator critique's
   member 9): amber words on a light amber fill, bold, never green */
.pp--acc .tg-missed {
  min-height: 22px; padding: 2px 8px; border-radius: 11px; background: var(--acc-pill-amber-bg); color: var(--acc-pill-amber-ink);
  font-size: 12px; font-weight: 700; line-height: 1.5; display: inline-flex; align-items: center;
}
.tg-tags { display: flex; flex-wrap: wrap; gap: 6px; }
.tg-tag {
  height: 24px; padding: 0 9px; border-radius: 6px; background: var(--tg-tag-bg); color: var(--tg-tag-fg);
  font-size: 12px; font-weight: 500; display: flex; align-items: center;
}
.tg-tag--on { background: var(--tg-tag-on-bg); color: var(--tg-tag-on-fg); }
.tg-actions { flex-shrink: 0; display: flex; flex-direction: column; align-items: stretch; gap: 8px; }
.tg-watch {
  height: 38px; padding: 0 16px; border-radius: 9px; background: var(--pp-btn-bg); font-weight: 600; font-size: 14px;
  display: flex; align-items: center; justify-content: center; gap: 8px; text-decoration: none;
}
.pp .tg-watch { color: var(--pp-btn-fg); }
.tg-ask-btn {
  height: 34px; padding: 0 12px; border-radius: 9px; border: 1px solid var(--pp-rule); background: var(--pp-card);
  color: var(--pp-ink); font-weight: 600; font-size: 13px;
}
.tg-ask {
  margin: 0 26px 20px 104px; padding: 16px; border-radius: 10px; background: var(--tg-field); border: 1px solid var(--pp-rule);
  display: flex; flex-direction: column; gap: 10px;
}
.tg-ask textarea {
  height: 76px; padding: 10px 12px; border-radius: 8px; border: 1px solid var(--pp-rule); background: var(--pp-card);
  color: var(--pp-ink); font: inherit; font-size: 14px; line-height: 1.5; resize: none;
}
.tg-ask textarea::placeholder { color: var(--pp-soft); }
.tg-ask-foot { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.tg-ask-note { font-size: 13px; color: var(--pp-soft); }
.tg-ask-send {
  flex-shrink: 0; height: 36px; padding: 0 14px; border-radius: 8px; border: none; background: var(--pp-btn-bg);
  color: var(--pp-btn-fg); font-weight: 600; font-size: 13px;
}
.tg-sent { margin: 0 26px 20px 104px; font-size: 14px; font-weight: 600; color: var(--pp-accent); }
.tg-none { margin: 0; padding: 24px 26px; font-size: 15px; line-height: 1.55; color: var(--pp-soft); }

@media (max-width: 760px) {
  .tg { border-radius: 12px; }
  .tg-head { padding: 18px 16px 16px; }
  .tg-head-row { flex-direction: column; align-items: stretch; gap: 14px; }
  .tg-search { width: 100%; }
  /* The board's placeholder, whole on a phone (finding C55). Chromium and WebKit keep about 14px
     at the right for the search field's clear button even while it's hidden on an empty field, so
     the button goes while the placeholder shows (it's back as soon as there's text), and the icon
     and padding sit a little closer. Below 380 the placeholder alone is 13px. */
  .tg-search-icon { left: 11px; }
  .tg-search input { padding: 0 8px 0 34px; }
  .tg-search input:placeholder-shown::-webkit-search-cancel-button { display: none; }
  .tg-h--page { font-size: 30px; }
  .tg-month-h { padding: 16px 16px 2px; }
  .tg-row-main { flex-wrap: wrap; gap: 14px; padding: 16px; }
  .tg-text { flex-basis: calc(100% - 70px); }
  .thumb.tg-thumb { width: 120px; --rthumb-radius: 8px; }
  .tg-thumb .rthumb-day { font-size: 20px; }
  .tg-thumb .rthumb-date { font-size: 11px; }
  /* with the frame: the title beside it, then the tags under both with the row's whole width, a pill
     growing to hold a tag too long for 1 line */
  .tg-row-main--thumb .tg-text { display: contents; }
  .tg-row-main--thumb .tg-title-line { flex: 1 1 0; min-width: 0; }
  .tg-row-main--thumb .tg-tags { flex-basis: 100%; }
  .tg-row-main--thumb .tg-tag { height: auto; min-height: 24px; padding: 4px 9px; line-height: 16px; }
  .tg-row-main--thumb ~ .tg-ask, .tg-row-main--thumb ~ .tg-sent { margin-left: 16px; }
  .tg-actions { flex-direction: row; flex-basis: 100%; }
  .tg-watch, .tg-ask-btn { flex: 1 1 0; }
  .tg-ask, .tg-sent { margin: 0 16px 16px; }
  .tg-ask-foot { flex-direction: column; align-items: stretch; }
  .tg-none { padding: 18px 16px; }
}

@media (max-width: 379px) {
  .tg-search input::placeholder { font-size: 13px; }
}
